import { C } from '../landing.theme'

const BRANDS = ['GLONG','PAHLEN','EMAUX','LANDY','AQUA-VIVA','BWT','ELBE','PROCOPI','REVIGLASS','ELECRO','ESPA','PICKS','MAX DAPRA','HX','ALTOGLASS','CGT','ABLE-TECH']

/* Premium frosted-glass pill with teal gradient border */
function BrandPill({ name }) {
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      padding: '10px 22px',
      borderRadius: 999,
      fontFamily: "'JetBrains Mono',monospace",
      fontSize: 11.5,
      fontWeight: 700,
      letterSpacing: '.14em',
      color: 'rgba(200,235,240,.82)',
      whiteSpace: 'nowrap',
      background: 'linear-gradient(135deg,rgba(15,163,177,.1) 0%,rgba(10,60,80,.12) 100%)',
      border: '1px solid rgba(31,200,214,.22)',
      boxShadow: '0 2px 12px rgba(0,0,0,.25),inset 0 1px 0 rgba(31,200,214,.1)',
      backdropFilter: 'blur(6px)',
      WebkitBackdropFilter: 'blur(6px)',
      transition: 'border-color .3s,box-shadow .3s,color .3s',
    }}>
      {name}
    </span>
  )
}

export default function Brands() {
  const row = [...BRANDS, ...BRANDS]
  return (
    <section style={{ background: C.bg0, padding: '60px 0', borderTop: `1px solid ${C.line}`, overflow: 'hidden', position: 'relative' }}>
      {/* ambient glow strip */}
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: '60%', height: 1, background: 'linear-gradient(90deg,transparent,rgba(31,200,214,.18),transparent)', pointerEvents: 'none' }}/>

      <div className="wrap" style={{ textAlign: 'center', marginBottom: 30 }}>
        <h2 style={{ fontSize: 'clamp(18px,2.8vw,28px)', color: '#fff', fontWeight: 800 }}>Бренды, с которыми мы работаем</h2>
        <p style={{ fontSize: 13.5, color: C.s3, marginTop: 8, fontFamily: "'JetBrains Mono',monospace", letterSpacing: '.08em' }}>Только сертифицированные производители</p>
      </div>

      <div style={{ overflow: 'hidden', WebkitMaskImage: 'linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent)', maskImage: 'linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent)' }}>
        <div style={{ display: 'flex', gap: 10, width: 'max-content', animation: 'marquee 34s linear infinite' }}>
          {row.map((b, i) => <BrandPill key={i} name={b}/>)}
        </div>
      </div>
    </section>
  )
}
